import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

export const templateRelayPatchCachingServers = document.createElement('template');

templateRelayPatchCachingServers.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <div class="relay-patch">
        <gz-dropdown combobox id="search-relay-input" labelWidth="240"></gz-dropdown>
        <gz-form-field id="custom-relay-field" class='' label=''>
            <gz-input id="custom-relay-input" gz-form-input placeholder="" inputWidth="240"></gz-input>
            <gz-input-error inputWidth="240"></gz-input-error>
        </gz-form-field>
        <gz-icon-button id="add-relay-button" disabled size="32" fontSize="20" buttonType="square" icon="ds-icon-add" buttonFill="primary"></gz-icon-button>
    </div>
    <gz-grid-view id="relay-caching-servers"></gz-grid-view>
  </div>
`;
